

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"class":[styles && styles["action-arrow"] || "action-arrow"].join(' '),"xmlns":"http://www.w3.org/2000/svg","width":"17","height":"14","viewBox":"0 0 17 14"}, rest), ["\n  ", h('g', {"fill":"none","fill-rule":"evenodd","transform":"translate(-1 -2)"}, ["\n    ", h('rect', {"width":"18","height":"18"}, []), "\n    ", h('path', {"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M2,9 L15,9"}, []), "\n    ", h('polyline', {"stroke":"currentColor","stroke-linecap":"round","stroke-width":"2","points":"10 3 16 9 10 15"}, []), "\n  "]), "\n"]);
};

        